export default "__VITE_ASSET__CUts2kM___"